import {
  faBan,
  faEye,
  faEyeSlash,
  faSave,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useEffect, useState } from "react";
import { Button, Form, InputGroup, Stack } from "react-bootstrap";
import Modal from "react-bootstrap/Modal";
import { UserDTO } from "../../../models/UserDTO";
import { Role } from "../../../models/Role";
import RoleService from "../../../services/role.service";

type Props = {
  onHide: () => void;
  onSave: (newUser: UserDTO) => void;
  show: boolean;
  user?: UserDTO | null;
  title?: string;
};

export const ModalUserForm = (props: Props) => {
  const [user, setUser] = useState<UserDTO>({
    userName: "",
    name: "",
    email: "",
    passwordHash: "",
    role: 0,
  });
  const [roles, setRoles] = useState<Role[]>([]);
  const [showPass, setShowPass] = useState(false);
  const [validated, setValidated] = useState(false);

  const loadUser = async () => {
    setUser({
      userName: props.user?.userName || "",
      name: props.user?.name || "",
      email: props.user?.email || "",
      passwordHash: props.user?.passwordHash || "",
      role: props.user?.roles ? props.user.roles[0]?.roleId : 0,
    });
  };

  const loadRoles = async () => {
    const rolesData = await RoleService.getRoles();
    setRoles(rolesData);
  };

  const handleInputChange = (e: any) => {
    const { name, value } = e.target;
    setUser({
      ...user,
      [name]: value,
    });
  };

  const handleOnSubmit = (event: any) => {
    event.preventDefault();
    const form = event.currentTarget;

    if (form.checkValidity() === false) {
      event.stopPropagation();
    }

    user.id = props.user?.id;
    props.onSave(user);
    setValidated(true);
  };

  const resetForm = () => {
    setUser({
      userName: "",
      name: "",
      email: "",
      passwordHash: "",
      role: 0,
    });
    setValidated(false);
    setShowPass(false);
  };

  useEffect(() => {
    loadUser();
    loadRoles();
  }, [props.show, props.user]);

  return (
    <Form validated={validated} noValidate>
      <Modal
        show={props.show}
        aria-labelledby="contained-modal-title-vcenter"
        centered
        backdrop="static"
        onHide={props.onHide}
      >
        <Modal.Header>
          <Modal.Title id="contained-modal-title-vcenter">
            {props.title}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Stack gap={3}>
            <Form.Group>
              <Form.Label>Usuario</Form.Label>
              <Form.Control
                type="text"
                maxLength={50}
                required={true}
                name="userName"
                value={user.userName}
                onChange={handleInputChange}
              />
            </Form.Group>
            <Form.Group>
              <Form.Label>Nombre</Form.Label>
              <Form.Control
                type="text"
                maxLength={50}
                required={true}
                name="name"
                value={user.name}
                onChange={handleInputChange}
              />
            </Form.Group>
            <Form.Group>
              <Form.Label>Email</Form.Label>
              <Form.Control
                type="email"
                placeholder="nombre@ejemplo.com"
                maxLength={50}
                required={true}
                name="email"
                value={user.email}
                onChange={handleInputChange}
              />
            </Form.Group>
            <Form.Group>
              <Form.Label>Contraseña</Form.Label>
              <InputGroup>
                <Form.Control
                  type={showPass === true ? "text" : "password"}
                  maxLength={50}
                  required={true}
                  name="passwordHash"
                  value={user.passwordHash}
                  onChange={handleInputChange}
                />
                <InputGroup.Text
                  onClick={() => setShowPass(!showPass)}
                  style={{ cursor: "pointer" }}
                >
                  <FontAwesomeIcon
                    icon={showPass === true ? faEyeSlash : faEye}
                  />
                </InputGroup.Text>
              </InputGroup>
            </Form.Group>
            <Form.Group>
              <Form.Label>Rol</Form.Label>
              <Form.Select
                aria-label="Default select example"
                required={true}
                name="role"
                value={user.role}
                onChange={handleInputChange}
              >
                <option>Seleccionar rol</option>
                {roles.map((item) => (
                  <option value={item.id}>{item.name}</option>
                ))}
              </Form.Select>
            </Form.Group>
          </Stack>
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="secondary"
            onClick={() => {
              !props.user?.id && resetForm();
              props.onHide();
            }}
          >
            <FontAwesomeIcon
              icon={faBan}
              style={{
                paddingRight: "3px",
              }}
            />
            <span className="ms-2">Cancelar</span>
          </Button>
          <Button type="submit" variant="primary" onClick={handleOnSubmit}>
            <FontAwesomeIcon
              icon={faSave}
              style={{
                paddingRight: "3px",
              }}
            />
            <span className="ms-2">Guardar</span>
          </Button>
        </Modal.Footer>
      </Modal>
    </Form>
  );
};
